<div class="p-4 space-y-3 flex flex-col h-full">

  <div class="flex items-center gap-3 flex-wrap">
    <h2 class="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
      <i class="fa-solid fa-layer-group text-app-teal-100"></i>Index Constituents
    </h2>

    <!-- Segmented picker: [S&P 500][Dow 30][Nasdaq 100][Nasdaq Composite].
         Per-index count labels come from the summary endpoint. -->
    <div class="inline-flex rounded border border-gray-300 dark:border-[#434863] overflow-hidden text-xs" role="group" aria-label="Index">
      <button
        *ngFor="let i of indexes"
        class="px-3 py-1 border-r border-gray-300 dark:border-[#434863] last:border-r-0 transition"
        [class.bg-app-teal-100]="index === i.key"
        [class.text-white]="index === i.key"
        [class.text-gray-700]="index !== i.key && countFor(i.key) > 0"
        [class.dark:text-gray-300]="index !== i.key && countFor(i.key) > 0"
        [class.text-gray-400]="index !== i.key && countFor(i.key) === 0"
        [class.dark:text-gray-500]="index !== i.key && countFor(i.key) === 0"
        [class.hover:bg-gray-50]="index !== i.key"
        [class.dark:hover:bg-app-blue-100]="index !== i.key"
        [disabled]="loading"
        [attr.title]="countFor(i.key) === 0 ? (i.label + ' — no data source configured yet') : i.label"
        (click)="setIndex(i.key)">
        {{ i.key }}
        <span class="opacity-70 ml-1 text-[10px]">({{ countFor(i.key) }})</span>
      </button>
    </div>

    <button class="dark-btn dark-btn-sm" (click)="reload()" [disabled]="loading">
      <i class="fa-solid fa-rotate-right mr-1" [class.fa-spin]="loading"></i>Reload
    </button>

    <app-grid-copy-menu [gridApi]="grid?.api"></app-grid-copy-menu>
    <app-copy-source-button
      [source]="'LSEG:INDEX_CONSTITUENTS:' + index"
      [tooltip]="'Redis key — same on ws + srvr2'">
    </app-copy-source-button>

    <span class="text-xs text-gray-500 dark:text-gray-400 ml-2">
      <strong>{{ rows.length }}</strong> constituent<span *ngIf="rows.length !== 1">s</span>
      in <code class="text-app-teal-100">LSEG:INDEX_CONSTITUENTS:{{ index }}</code>
      <span *ngIf="loadedAt" class="ml-2">
        · loaded {{ loadedAt | date:'MMM d, y, h:mm:ss a' }}
      </span>
    </span>
  </div>

  <p class="text-xs text-gray-500 dark:text-gray-400">
    Each list is populated by <code>lseg-service</code>'s
    <code>pump_index_constituents</code> — mirrors the corresponding
    <code>symbol-list:&lt;name&gt;</code> SET from f2-admin-service's
    SymbolListsService (source-of-truth is <code>F2Tech-WebDev-v2/common-symbol-lists</code>).
    Consumers: Genesis COG's SP500 flag (theo-trade-service
    <code>redis.service.ts:152</code> → <code>spx_map</code>), and any
    future scanner that wants per-index membership.
  </p>

  <ag-grid-angular
    class="w-full flex-1 min-h-[520px]"
    [rowData]="rows"
    [gridOptions]="grid.options"
    [statusBar]="grid.statusBar"
    [columnDefs]="columnDefs"
    [theme]="theme">
  </ag-grid-angular>
</div>
